export function createApplicationRequest(card, personalInfo, incomeExpenses, occupation, authUsers, application, offerCode) {
  const mailingAddress = 
    ( personalInfo.mailingAddress.address1 !== personalInfo.address.address1 || 
      personalInfo.mailingAddress.address2 !== personalInfo.address.address2 ||
      personalInfo.mailingAddress.city !== personalInfo.address.city ||
      personalInfo.mailingAddress.province !== personalInfo.address.province ||
      personalInfo.mailingAddress.postalCode !== personalInfo.address.postalCode ) ?    
    {
      line1: personalInfo.mailingAddress.address1,
      line2:  (personalInfo.mailingAddress.address2 === "") ? null : personalInfo.mailingAddress.address2,
      city: personalInfo.mailingAddress.city,
      province: personalInfo.mailingAddress.province,
      postalCode: personalInfo.mailingAddress.postalCode      
    } : null;
  //PBI 441343: Retrieving UTM parameters from session storage
  const utmParams = JSON.parse(sessionStorage.getItem('utmParams'));
  utmParams.utmSource = (utmParams.utmSource === "") ? "(not set)" : utmParams.utmSource
  utmParams.utmMedium = (utmParams.utmMedium === "") ? "(not set)" : utmParams.utmMedium
  utmParams.utmCampaign = (utmParams.utmCampaign === "") ? "(not set)" : utmParams.utmCampaign
  utmParams.utmContent = (utmParams.utmContent === "") ? "(not set)" : utmParams.utmContent

  return {
    card, 
    personalInfo: {
      firstname: personalInfo.firstName,
      middlename: (personalInfo.middleName === "") ? null : personalInfo.middleName,
      lastname: personalInfo.lastName,
      birthdate: personalInfo.birthdate,
      // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
      mobilePhoneNumber: personalInfo.mobilePhone,
      homePhoneNumber: (personalInfo.homePhone === "") ? null: personalInfo.homePhone,
      email: (personalInfo.email === "") ? null : personalInfo.email,
      accountPassword: personalInfo.accountPassword,
      address: {
          line1: personalInfo.address.address1,
          line2: (personalInfo.address.address2 === "") ? null : personalInfo.address.address2,
          city: personalInfo.address.city,
          province: personalInfo.address.province,
          postalCode: personalInfo.address.postalCode
      },
      mailingAddress: mailingAddress
    },
    authUsers: authUsers.map(user => {
      return {
        firstname: user.firstName,
        middlename: (user.middleName === "") ? null : user.middleName,
        lastname: user.lastName,
        birthdate: user.birthdate,
        // PBI 441341 VOA: Replace the drop-down for the Primary and Authorized User Phone fields with two separate input fields for Mobile and Home phone numbers
        mobilePhoneNumber: user.mobilePhone,
        homePhoneNumber: (user.homePhone === "") ? null: user.homePhone,
        email: (user.email === "") ? null : user.email,
        address: {
          line1: user.address1,
          line2: (user.address2 === "") ? null : user.address2,
          city: user.city,
          province: user.province,
          postalCode: user.postalCode
        },
        noc: (user.noc === "") ? null : user.noc, 
        occupationName: (user.occupationName === "") ? null : user.occupationName, 
        occupationStatus: (user.status === "") ? null : user.status
      }
    }),
    housingStatus: personalInfo.housingStatus,
    moveInDate: personalInfo.moveInDate,
    occupation: {
      employer: (occupation.employer === "") ? null : occupation.employer,
      occupationStatus: occupation.status,
      industry: (occupation.industry === "") ? null : occupation.industry,
      occupationName: (occupation.occupationName === "") ? null : occupation.occupationName,
      noc: (occupation.noc === "") ? null : occupation.noc,
      employmentStart: (occupation.employedSince === "") ? null : occupation.employedSince,
      workPhone: (occupation.phone === "") ? null : occupation.phone
    },
    incomeStatement: {
      monthlyIncome: (incomeExpenses.income === "") ? null : incomeExpenses.income,
      monthlyRentOrMortgageExpense: (incomeExpenses.rent === "") ? null : incomeExpenses.rent,
      monthlyLineOfCreditExpense: (incomeExpenses.loans === "") ? null : incomeExpenses.loans,
      monthlyCreditCardExpense: (incomeExpenses.creditcards === "") ? null : incomeExpenses.creditcards,
      annualHouseholdIncome: (incomeExpenses.householdincome === "") ? 0 : incomeExpenses.householdincome,
      investableFunds: (incomeExpenses.investmentincome === "") ? 0 : incomeExpenses.investmentincome,
    },
    isMember: application.isMember,
    OfferCode: offerCode,
    //PBI 441343: Sending UTM parameters along with application request data to the backend
    utmParams: {
      utmSourceMedium: (utmParams.utmSource === "" || utmParams.utmMedium === "") ? null : (utmParams.utmSource + " / " + utmParams.utmMedium).substring(0, 45),
      utmCampaign: (utmParams.utmCampaign === "") ? null: (utmParams.utmCampaign).substring(0, 50),
      utmContent: (utmParams.utmContent === "") ? null: (utmParams.utmContent).substring(0, 55)
    },
    isBpi: application.bpi
  }
}

export function createVerificationRequest(questions) {
  return {
    questionAnswers: 
      questions.map(question => {return {
        Id: question.id,
        Value: question.answer
      }})    
  }
}


// WEBPACK FOOTER //
// ./src/utils/Request.js